// extracted by mini-css-extract-plugin
export default {"select_kpi":"KpisSettingsPopup_select_kpi__UO710","text_field":"KpisSettingsPopup_text_field__9DUiF"};